import loadable from '@loadable/component';
import { Loader } from '../Loader';

const Settings = loadable(() => import('./Settings'), { fallback: <Loader /> });

export { Settings };
export type { SettingsMenuItemKey } from './Settings';
